export default __webpack_public_path__ + "static/media/React95Video-Numbers.1b0c9ed8.woff2";